function logout() {
  window.location.href = "/logout"
}

function createLogoutOnFailureHandler() {
  return function () {
    logout();
  }
}

export {logout, createLogoutOnFailureHandler};
